export default __webpack_public_path__ + "static/media/rifan_litil-min.26b692a1.png";